import type { SingleValue } from "react-select";

import { getSelectClasses } from "@/utils/filter-styles";
import { SelectInput } from "components/Select";

import { useStoreAccessFilterActions } from "../../filter/hooks/actions";
import { useStoreAccessFilterState } from "../../filter/hooks/filterState";
import { CPF_FILTER } from "../../filter/types";

import {
  BLOCKED_OPTIONS,
  BlockedOption,
  CPF_FILTER_OPTIONS,
  CpfFilterOption,
} from "./types";

/**
 * Filtros globais (cpfFilter + blocked) aplicados à tab ATIVA. Seleção de
 * loja vive no `StoreContextHeader` (contexto, não filtro).
 */
export default function SelectFilters() {
  const { updateTabFilter } = useStoreAccessFilterActions();
  const { activeTab, users, operators } = useStoreAccessFilterState();
  const activeFilters = activeTab === "users" ? users : operators;

  const handleCpfFilterChange = (option: SingleValue<CpfFilterOption>) => {
    const value = option?.value ?? CPF_FILTER.VALID;
    updateTabFilter({ tab: activeTab, key: "cpfFilter", value });
    updateTabFilter({ tab: activeTab, key: "page", value: 1 });
  };

  const handleBlockedChange = (option: SingleValue<BlockedOption>) => {
    const value =
      option?.value === "true"
        ? true
        : option?.value === "false"
          ? false
          : null;
    updateTabFilter({ tab: activeTab, key: "blocked", value });
    updateTabFilter({ tab: activeTab, key: "page", value: 1 });
  };

  const getSelectedCpfFilter = () =>
    CPF_FILTER_OPTIONS.find(opt => opt.value === activeFilters.cpfFilter) ||
    CPF_FILTER_OPTIONS[0];

  const getSelectedBlocked = () => {
    if (activeFilters.blocked === null || activeFilters.blocked === undefined)
      return BLOCKED_OPTIONS[0];
    return (
      BLOCKED_OPTIONS.find(opt => opt.value === String(activeFilters.blocked)) ||
      BLOCKED_OPTIONS[0]
    );
  };

  return (
    <>
      <div className="flex flex-col gap-0.5">
        <span className="text-xs font-medium text-muted-foreground">CPF</span>
        <SelectInput
          options={CPF_FILTER_OPTIONS}
          placeholder="Filtro CPF"
          value={getSelectedCpfFilter()}
          onChange={handleCpfFilterChange}
          className={`${getSelectClasses(true)} h-8 min-w-[150px]`}
          classNamePrefix="an-simple-select"
          isClearable={false}
        />
      </div>
      <div className="flex flex-col gap-0.5">
        <span className="text-xs font-medium text-muted-foreground">Status</span>
        <SelectInput
          options={BLOCKED_OPTIONS}
          placeholder="Status"
          value={getSelectedBlocked()}
          onChange={handleBlockedChange}
          className={`${getSelectClasses(true)} h-8 min-w-[150px]`}
          classNamePrefix="an-simple-select"
          isClearable={false}
        />
      </div>
    </>
  );
}
